import React, { useState, useContext, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import API from "../api/axios"; // ✅ USE GLOBAL API
import { AuthContext } from "../context/AuthContext";
import "../styles/main.css";

const Login = () => {
  const [email] = useState("tomarnitin713@gmail.com");
  const [otp, setOtp] = useState("");
  const [step, setStep] = useState("email");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [resendCooldown, setResendCooldown] = useState(0);

  const otpInputRef = useRef(null);
  const navigate = useNavigate();
  const { setUser } = useContext(AuthContext);

  /* ================= COOLDOWN ================= */
  useEffect(() => {
    if (resendCooldown <= 0) return;
    const timer = setInterval(() => setResendCooldown((prev) => prev - 1), 1000);
    return () => clearInterval(timer);
  }, [resendCooldown]);

  /* ================= SEND OTP ================= */
  const handleSendOtp = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    setMessage("");

    try {
      const res = await API.post("/admin/send-otp", { email });

      setMessage(res.data.message || "OTP sent successfully!");
      setStep("otp");
      setResendCooldown(30);
      setOtp("");

      setTimeout(() => otpInputRef.current?.focus(), 400);
    } catch (err) {
      console.error(err);
      setError(err.response?.data?.message || "Failed to send OTP.");
    } finally {
      setLoading(false);
    }
  };

  /* ================= VERIFY OTP ================= */
  const handleVerifyOtp = async (e) => {
    e.preventDefault();

    if (!otp.trim()) return setError("Please enter OTP");

    setLoading(true);
    setError("");
    setMessage("");

    try {
      const res = await API.post("/admin/verify-otp", { email, otp });

      const { token, user } = res.data || {};

      if (!token || !user) throw new Error("Invalid response");

      localStorage.setItem("admin", JSON.stringify({ ...user, token }));
      setUser({ ...user, token });

      setMessage("✅ Login successful!");
      setTimeout(() => navigate("/"), 1200);

    } catch (err) {
      console.error(err);
      setError(err.response?.data?.message || "Invalid OTP");
    } finally {
      setLoading(false);
    }
  };

  /* ================= RESEND ================= */
  const handleResendOtp = async () => {
    if (resendCooldown > 0 || loading) return;

    setLoading(true);
    setError("");
    setMessage("");

    try {
      const res = await API.post("/admin/send-otp", { email });

      setMessage(res.data.message || "OTP resent!");
      setResendCooldown(30);
      setOtp("");

      setTimeout(() => otpInputRef.current?.focus(), 400);
    } catch (err) {
      console.error(err);
      setError("Failed to resend OTP");
    } finally {
      setLoading(false);
    }
  };

  /* ================= UI ================= */
  return (
    <div className="admin-login-page">
      <div className="login-left">
        <div className="login-card">
          <h2 className="login-title">Admin OTP Login</h2>

          {error && <p className="error-msg">{error}</p>}
          {message && <p className="success-msg">{message}</p>}

          <form onSubmit={step === "email" ? handleSendOtp : handleVerifyOtp}>
            {step === "email" ? (
              <>
                <input
                  type="email"
                  value={email}
                  readOnly
                  className="readonly-input"
                />
                <button disabled={loading} className="primary-btn">
                  {loading ? "Sending..." : "Send OTP"}
                </button>
              </>
            ) : (
              <>
                <input
                  ref={otpInputRef}
                  type="text"
                  placeholder="Enter OTP"
                  value={otp}
                  onChange={(e) => setOtp(e.target.value.replace(/\D/g, ""))}
                  maxLength={6}
                />

                <button
                  disabled={loading || otp.length < 6}
                  className="primary-btn"
                >
                  {loading ? "Verifying..." : "Verify OTP"}
                </button>

                <button
                  type="button"
                  onClick={handleResendOtp}
                  disabled={resendCooldown > 0}
                  className="resend-btn"
                >
                  {resendCooldown > 0
                    ? `Resend in ${resendCooldown}s`
                    : "Resend OTP"}
                </button>
              </>
            )}
          </form>
        </div>
      </div>

      <div className="login-right">
        <img
          src="https://i.ibb.co/MwHMzcZ/Whats-App-Image-2025-08-05-at-10-30-04-AM-removebg-preview.png"
          alt="Logo"
          className="company-logo"
        />
        <p className="brand-tagline">Build Empire — Smart Digital Solutions</p>
      </div>
    </div>
  );
};

export default Login;